"use strict";
const _ = require('lodash');
const { rowIsHandlingCostRow, rowIsSRSRow, getNumberOfOrderUnitsOnRow, } = require('./properties');
const { filterOutAlcTaxCancellingRows } = require('./alcTaxAdjustments');
const filterOutHandlingCostRows = rows => rows.filter(x => !rowIsHandlingCostRow(x));
const getHandlingCostRows = rows => rows.filter(x => rowIsHandlingCostRow(x));
const filterOutSRSRows = rows => rows.filter(x => !rowIsSRSRow(x));
const getSRSRows = rows => rows.filter(x => rowIsSRSRow(x));
const filterOutUtilityArticles = rows => rows.filter(x => !(x.article && x.article.utilityArticle));
const calculateTotalForOrder = rows => {
    const totalExclVATnRecycle = _.round(_.sum(rows.map(r => r.total)), 2);
    return totalExclVATnRecycle;
};
const getNumberOfOrderUnitsOnRows = rows => _.sumBy(rows, x => getNumberOfOrderUnitsOnRow(x));
function removeSpecialRows(rows = []) {
    return filterOutSRSRows(filterOutHandlingCostRows(filterOutAlcTaxCancellingRows(rows)));
}
module.exports = {
    calculateTotalForOrder,
    getNumberOfOrderUnitsOnRows,
    removeSpecialRows,
    getHandlingCostRows,
    filterOutHandlingCostRows,
    filterOutUtilityArticles,
    getSRSRows,
};
